<template>
  <span class="dli-loading-3"></span>
</template>

<script>
import { defineComponent, reactive, computed } from 'vue'

export default defineComponent({
  props: {
  },
  components: {
  },
  setup (props, context) {
  }
})
</script>

<style lang="scss" scoped>
.dli-loading-3 {
  vertical-align: middle;
  color: #666;
  line-height: 1;
  margin: auto;
  display: block;
  width: 1em;
  height: 1em;
  border: 0.12em solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotate 1s linear infinite;
  margin-top: 40px;
}

.x2 {
  width: 2em;
  height: 2em;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
